<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Zatwierdzanie zamówienia' | translate }}</h3>
        <button
                iccIconButton
                (click)="close()"
                appearance="flat"
            >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <p class="quotation-code">{{'SALES_DOCUMENT|Nr zamówienia:' | translate}} <b>{{data.document.documentNumber.join('')}}</b></p>
        <div class="order-options">
            <div class="icc-radio-buttons">

                <span>

                    <icc-radio
                        id="confirm-later"
                        name="mode"
                        [value]="true"
                        (valueChange)="confirmLater = $event"
                    >
                        {{  'SALES_DOCUMENT|Zatwierdzenie przez kupującego' | translate }}
                    </icc-radio>

                </span>
                <span>

                    <icc-radio
                        id="confirm-now"
                        name="mode"
                        [value]="false"
                        (valueChange)="confirmLater = $event"
                    >
                        {{  'SALES_DOCUMENT|Zatwierdź od razu' | translate }}
                    </icc-radio>

                </span>

            </div>
        </div>

    </div>

    <div class="dialog-footer flex-vertical">

        <div class="flex-horizontal w-100">

            <button iccButton (click)="close()">{{ 'INTERFACE|Anuluj' | translate}}</button>
            <button iccButton (click)="confirmOrder()" [disabled]="!canBeOrdered">{{ 'SALES_DOCUMENT|Zatwierdź zamówienie' | translate}}</button>

        </div>
        <div class="w-100" *ngIf="!messages.length && message">
            <p [class.error]="messageState === 'error'" class="dialog-message">{{ message }}</p>
        </div>
        <div class="w-100" *ngIf="messages.length">
            <p [class.error]="messageState === 'error'" class="dialog-message" *ngFor="let msg of messages">{{ msg }}</p>
        </div>
    </div>

</div>
<div
    class="curtain"
    (click)="close()"
></div>
